<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" :model="searchForm" ref="searchForm">
          <el-form-item label="国补类型" prop="type" label-width="70px">
            <el-select v-model="searchForm.type" multiple collapse-tags clearable @change="typeChange">
              <el-option v-show="!all" label="全部" value=""></el-option>
              <el-option v-show="all" label="取消所有" value="cancleAll"></el-option>
              <el-option v-for="item in typeList" :label="item.stateSubsidiesName" :value="item.stateSubsidiesCode" :key="item.stateSubsidiesCode" />
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="editRow(null)">新增</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-loading="loading"
      >
        <el-table-column label="序号" prop="" width="50" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (tableData.pageNum - 1) * tableData.pageSize }}
          </template>
        </el-table-column>
        <el-table-column label="国补类型" prop="stateSubsidiesName" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="适用店铺" prop="storeName" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="更新人" prop="userName" width="70"></el-table-column>
        <el-table-column label="更新时间" prop="dt" width="160"></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="160">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="editRow(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" class="red-text-btn" @click="delRow(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>
    <edit-dialog :visible.sync="isShowEdit" v-if="isShowEdit" :rowData="rowData" :storeList="storeList" @success="onSearch" />
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin'
import editDialog from './edit.vue';
export default {
  name: 'NationalSubsidiesType',
  mixins: [tableMixin, pagePathMixin],
  components: { editDialog },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      searchFormData: [],
      searchForm: {
        type: [],
      },
      all: false,
      isShowEdit: false,
      rowData: [],
      typeList: [],
      storeList: [],
    };
  },
  computed: {},
  mounted() {
    this.getTypeOptions();
    this.getStoreOptions();
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.getStoreOptions()
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: this.searchForm.type.join(','),
      };
      this.$q.configurationCenter
        .stateSubsidiesPage({ data: data })
        .then((res) => {
          this.tableData = res.data;
        })
        .finally((_) => {
          this.loading = false;
        });
    },

    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    typeChange(val) {
      this.all = this.typeList.length == val.length;
      if (val.includes("")) {
        this.searchForm.type = this.typeList.map(v=>v.stateSubsidiesCode);
        this.all = true;
      } else if (val.includes("cancleAll")) {
        this.searchForm.type = [];
        this.all = false;
      }
    },
    editRow(row) {
      this.rowData = row ? { ...row } : row;
      this.isShowEdit = true;
    },
    async delRow(row) {
      let status = await this.$confirm('是否确认删除该条数据？', '提示', {
        type: 'warning',
      });
      if (status !== 'confirm') return;
      let form = new FormData();
      form.append('stateSubsidiesCode', row.stateSubsidiesCode);
      this.$q.configurationCenter.deleteStateSubsidies({ data: form }).then((res) => {
        if (res.code == 200) {
          this.$message.success('删除成功');
          this.onSearch();
        }
      });
    },
    getTypeOptions() {
      this.$q.configurationCenter.queryStateSubsidiesType().then((res) => {
        this.typeList = res.data;
      });
    },
    getStoreOptions() {
      this.$q.configurationCenter.queryStoreList().then((res) => {
        this.storeList = res.data;
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-select__tags-text {
  display: inline-block;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
>>> .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px
}
</style>
